import type { FlightLeg } from '../../../domain/types'
import { useIntl } from '@/intl'
import { getFlightStopsCount, getFlightTitle } from '../../utils/flightDetails'
import { FlightDetailsCard } from './FlightDetailsCard'
import { FlightDetailsEmptyCard } from './FlightDetailsEmptyCard'

export type FlightDirection = 'inbound' | 'outbound'

const NO_FLIGHT_TITLE_KEY = {
  inbound: 'booking_details_flight_inbound_no_flight_title',
  outbound: 'booking_details_flight_outbound_no_flight_title',
}

interface FlightDirectionCardProps {
  direction: FlightDirection
  legs: FlightLeg[] | null
  isCancelled: boolean
  showDirectLabel?: boolean
  showLuggageSection?: boolean
  showAirlineServices?: boolean
}

export function FlightDirectionCard({
  direction,
  legs,
  isCancelled,
  showDirectLabel = false,
  showLuggageSection = false,
  showAirlineServices = false,
}: FlightDirectionCardProps) {
  const { formatMessage } = useIntl()

  if (!legs?.length) {
    return (
      <FlightDetailsEmptyCard
        direction={direction}
        noFlightTitle={formatMessage({ id: NO_FLIGHT_TITLE_KEY[direction] })}
      />
    )
  }

  const stopsCount = getFlightStopsCount(legs)
  const subtitle = stopsCount > 0
    ? formatMessage({ id: 'booking_details_flight_stops_count' }, { count: stopsCount })
    : showDirectLabel
      ? formatMessage({ id: 'booking_details_flight_direct' })
      : undefined

  return (
    <FlightDetailsCard
      title={getFlightTitle(legs)}
      subtitle={subtitle}
      legs={legs}
      direction={direction}
      isCancelled={isCancelled}
      showLuggageSection={showLuggageSection}
      showAirlineServices={showAirlineServices}
    />
  )
}
